import React, { useEffect, useRef, useState } from 'react';

import { loaderClass } from '../../elements/common/TableLoader';
import axiosCRM from '../../services/MyAxios';

function FileManager() {
    const iframe = useRef<HTMLIFrameElement>();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadFileManagerToIframe(iframe.current);
    }, []);

    return (
        <div className={`shadow-sm ${loaderClass(loading)}`}>
            <iframe
                ref={iframe}
                src="about:blank"
                style={{ height: 'calc(100vh - 6.5rem)' }}
                className={`w-100 border-0 ${loading ? 'invisible' : ''}`}
                title="FileManager"
                onLoad={() => setLoading(false)}
            />
        </div>
    );
}

/**
 * To correctly display 'FileManager' in an 'iframe', you need to disable PhpDebugBar in the .env file.
 * DEBUGBAR_ENABLED=false
 * Otherwise, a security violation error will occur:
 * The content located at 'http://{domain}/crea/superadmin/file_manager'
 * cannot load data from 'blob://{domain}/_debugbar/assets/javascript?v={random}'.
 */
export function loadFileManagerToIframe(iframe: HTMLIFrameElement, onload?: () => void) {
    const url = `${window.location.pathname.match(/\/crea\/[a-zA-Z-]*/)}/filemanager`;

    axiosCRM.get(url).then((response) => {
        if (onload) {
            iframe.onload = onload;
        }

        iframe.src = URL.createObjectURL(new Blob([response.data], { type: 'text/html' }));
    });
}

export default FileManager;
